import React from 'react';
import ImgIconComp from './imgcomp';
import { withTranslation } from 'react-i18next';

class CustomeAttrDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCatShow: false,
      catId: 0, // need to cahngea as array or take data from json value
      catName: 'name', // need to cahngea as array or take data from json value
      showMultiList: false,
    };
    this.updateAttributeItem = this.updateAttributeItem.bind(this);
  }

  updateAttributeItem(attributeId, filedId, selectedValue) {
    const customAttribute = this.props.customAttribute.map((item) => {
      item.attributes.map((filed) => {
        if (filed.id == attributeId) {
          if (filedId == 1 || filedId == 2 || filedId == 3) {
            filed.ca_value = selectedValue;
          }
          if (filedId == 4) {
            filed.ca_value = selectedValue;
          }
        }
        return filed;
      });
      return item;
    });

    this.props.updateCustomAttribute(customAttribute);
  }

  render() {
    const { t } = this.props;
    const { listCatShow } = this.state;
    let { customAttribute } = this.props;
    customAttribute = customAttribute.sort((a, b) => b.id - a.id);
    customAttribute = customAttribute.map((item) => {
      item.attributes.sort((a, b) => b.id - a.id);
      return item;
    });
    return (
      <div>
        {
            (customAttribute.length)
              ? customAttribute.map((item, index) => (
                <CustomAttributeComp attributeItem={customAttribute[index]} updateAttributeItem={this.updateAttributeItem} canEditAttribute={this.props.canEditAttribute} t={t}/>
              ))
              : ''
                    }
      </div>

    );
  }
}

class CustomAttributeComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCatShow: false,
      catId: 0, // need to cahngea as array or take data from json value
      catName: 'name', // need to cahngea as array or take data from json value
      showMultiList: false,
    };
    this.discPopup = this.discPopup.bind(this);
  }

  discPopup(event, status, id) {
    if (status == 1) {
      if ($(`#head_${id}`).width() > 300) {
        $(event.target).next('.discPopup').css({ right: '0px' });
        $(event.target).next('.discPopup').css({ left: -300 });
      } else {
        const wedth = 600 - $(`#head_${id}`).width();
        $(event.target).next('.discPopup').css({ width: `${wedth}px` });
      }
      $(event.target).next('.discPopup').show();
    } else {
      $(event.target).next('.discPopup').hide();
    }
  }

  render() {
    const { t } = thi.props;
    const { listCatShow } = this.state;
    const { attributeItem } = this.props;
    return (
      <div className="attrDisplay">
        <div style={{ display: 'inline-block' }} className="catNameHead">
          <div className="attrName truncateText " id={`head_${attributeItem.id}`} title={attributeItem.name}>{attributeItem.name}</div>
        </div>
        {
              attributeItem.description
              && (
              <div onMouseOver={e => this.discPopup(e, 1, attributeItem.id)} onMouseOut={e => this.discPopup(e, 0, attributeItem.id)} className="openAHide">
                <img src={`${wbConfig.imageCdnUrl}/images/goal/help_small.png`} />
                <div className="discPopup" style={{ display: 'none' }}>
                  {attributeItem.description}
                </div>
              </div>
              )
            }
        <div className="contentWrap">

          {
                (attributeItem.attributes.length)
                  ? Object.keys(attributeItem.attributes).map((item, index) => (
                    <WsAttributeComp attribute={attributeItem.attributes[index]} updateAttributeItem={this.props.updateAttributeItem} canEditAttribute={this.props.canEditAttribute} t={t}/>
                  ))
                  : ''
                        }

        </div>
      </div>
    );
  }
}

class WsAttributeComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      catId: 0, // need to cahngea as array or take data from json value
      catName: 'name', // need to cahngea as array or take data from json value
    };
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(e, attributeId, filedId) {
    const selectedValue = e.target.value;
    this.props.updateAttributeItem(attributeId, filedId, selectedValue);
  }

  render() {
    const { t } = useTranslation();
    const { attribute } = this.props;
    const { canEditAttribute } = this.props;
    return (

      <div>
        {
              (attribute.field_type == 'Text field')
                ? (
                  <div className="coluems">
                    <div className="filedName truncateText" title={attribute.name}>{attribute.name}</div>
                    {
                  (canEditAttribute) ? <input type="text" placeholder={t("Enter the value")} onChange={e => this.changeValue(e, attribute.id, attribute.field_type_id)} name="cAname[{attribute.id}]" className="filedType  textFiled" value={attribute.ca_value} />
                    : <div className="filedData">{attribute.ca_value}</div>
                }

                  </div>
                ) : ''
            }
        {
              (attribute.field_type == 'Multi-line text area')
                ? (
                  <div className="coluems">
                    <div className="filedName truncateText" title={attribute.name}>{attribute.name}</div>
                    <div className="filedType truncateText">
                      {
                    (canEditAttribute) ? <textarea maxLength="" placeholder={t("Enter the value")} onChange={e => this.changeValue(e, attribute.id, attribute.field_type_id)} name="cAname[{attribute.id}]" className="teaxtArea" value={attribute.ca_value} />
                      : <div className="filedData">{attribute.ca_value}</div>
                  }
                    </div>
                  </div>
                ) : ''
            }
        {
              (attribute.field_type == 'Dropdown List') ? (
                <div className="coluems">
                  <div className="filedName truncateText" title={attribute.name}>{attribute.name}</div>
                  { (attribute.field_values.length && canEditAttribute) ? <ListCategory attribute={attribute} updateAttributeItem={this.props.updateAttributeItem} /> : attribute.ca_value }
                </div>
              ) : ''
            }
        {

              (attribute.field_type == 'Multi-select Dropdown') ? (
                <div className="coluems">
                  <div className="filedName truncateText" title={attribute.name}>{attribute.name}</div>
                  { (attribute.field_values.length && canEditAttribute) ? <ListMultiCategory attribute={attribute} updateAttributeItem={this.props.updateAttributeItem} /> : attribute.ca_value }

                </div>
              ) : ''
            }

      </div>

    );
  }
}

class ListCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCatShow: false,
      caValue: this.props.attribute.ca_value || '',
    };
    this.handleClick = this.handleClick.bind(this);
    this.showCategory = this.showCategory.bind(this);
    this.selectItem = this.selectItem.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick, true);
  }

  handleClick(e) {
    if (!$('.popupClick').is(e.target) // if the target of the click isn't the container...
          && $('.popupClick').has(e.target).length === 0) {
      this.setState({
        listCatShow: false,
      });
    }
  }

  showCategory() {
    this.setState({
      listCatShow: true,
    });
  }

  selectItem(selectedValue) {
    this.setState({
      listCatShow: false,
      caValue: selectedValue,
    });
    const { attribute } = this.props;
    this.props.updateAttributeItem(attribute.id, attribute.field_type_id, selectedValue);
  }

  render() {
    const { caValue } = this.state;
    const { listCatShow } = this.state;
    const { attribute } = this.props;
    return (
      <div className="filedType">
        <div className="truncateText multiSelDrop " onClick={e => this.showCategory()}>{(caValue == '' || caValue == null) ? '-- Select Values --' : caValue}</div>
        <ImgIconComp class="dropDIcon multiSelDropDIcon" id="arrow_down_gray" width="13" height="10" />
        <div className="popupClick ">
          { listCatShow && attribute.field_values.length && <ListCategoryItem selectItem={this.selectItem} catList={attribute.field_values} /> }
        </div>
      </div>
    );
  }
}

class ListCategoryItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { catList } = this.props;
    return (
      <div className="typeSelectWrap">
        {
          (catList.length)
            ? catList.map((item, index) => (
              <div data-value="{item.value}" onClick={e => this.props.selectItem(item.value)} className="option">{item.value}</div>
            ))
            : ''
        }

      </div>
    );
  }
}

class ListMultiCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCatShow: false,
      caValue: this.props.attribute.ca_value || '',
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick, true);
  }

  handleClick(e) {
    if (!$('.popupClick').is(e.target) // if the target of the click isn't the container...
          && $('.popupClick').has(e.target).length === 0) {
      this.setState({
        listCatShow: false,
      });
    }
  }

  showCategory() {
    this.setState({
      listCatShow: true,
    });
  }

  selectItem(selectedValue) {
    this.setState({
      listCatShow: false,
      caValue: selectedValue,
    });
    const { attribute } = this.props;
    this.props.updateAttributeItem(attribute.id, attribute.field_type_id, selectedValue);
  }

  render() {
    const { caValue } = this.state;
    const { listCatShow } = this.state;
    const { attribute } = this.props;
    return (
      <div className="filedType">
        <div className="truncateText multiSelDrop " onClick={e => this.showCategory()}>{(caValue == '' || caValue == null) ? '-- Select Values --' : caValue}</div>
        <ImgIconComp class="dropDIcon multiSelDropDIcon" id="arrow_down_gray" width="13" height="10" />
        <div className="popupClick ">
          { listCatShow && attribute.field_values.length && <ListMultiCategoryItem selectItem={this.selectItem} fields={attribute.field_values} /> }
        </div>
      </div>
    );
  }
}

class ListMultiCategoryItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: this.props.fields,
    };
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(e, index) {
    const _this = this;
    const { field_id } = this.props;
    const fields = this.state.fields.map((field, i) => {
      if (index == i) {
        const st = field.checkItem;
        if (st == true) {
          field.checkItem = false;
        } else {
          field.checkItem = true;
        }
      }
      return field;
    });
    setTimeout(() => _this.setState({
      fields,
    }), 10);
    const sel_value = [];
    this.state.fields.map((field, i) => {
      if (field.checkItem) {
        sel_value.push(field.value);
      }
    });
    this.props.selectItem(sel_value.toString());
  }

  render() {
    const { fields } = this.state;
    const { field_id } = this.props;
    return (
      <div className="typeSelectWrap">
        {
          fields.map((field, index) => (
            <div data-value={field.checkItem} className="option">
              { field.checkItem
              && (
              <div>
                <input type="checkbox" className="popupClick grp-meeting-attendee-select" checked value={field.value} onChange={e => this.changeValue(e, index)} />
                <label>{field.value}</label>
              </div>
              )
            }
              { !field.checkItem
              && (
              <div>
                <input type="checkbox" className="popupClick grp-meeting-attendee-select" value={field.value} onChange={e => this.changeValue(e, index)} />
                <label>{field.value}</label>
              </div>
              )
            }
            </div>
          ))
        }
      </div>
    );
  }
}

export default withTranslation()(CustomeAttrDisplay);
